// src/features/news/newsSlice.js
import { createSlice } from "@reduxjs/toolkit";
// import { ImageAds } from "../../assets/Anh1.jpg";
import ImageAds from "../../assets/Anh1.jpg";
import ImageBanner from "../../assets/LIEN-HE-QUANG-CAO.png";
import ImageKatec from "../../assets/LIEN-HE-QUANG-CAO_Katec.jpg";
import ImageTrangNguyen from "../../assets/LIEN-HE-QUANG-CAO_TrangNguyen.jpg";

const initialState = {
  articles: [
    {
      id: 1,
      title: "Tiếp tục kết nối, vun đắp tình đồng hương trên đất Tây Đô",
      date: "29/07/2024",
      image: ImageAds,
      isMain: true,
    },
    {
      id: 2,
      title:
        "Câu lạc bộ doanh nhân đồng hương Bạc Liêu, Cà Mau tại TP Cần Thơ vận động trên 3,3 tỉ đồng thực hiện nhiều hoạt động từ thiện xã hội",
      date: "29/07/2024",
      image: ImageAds,
      isMain: false,
    },
    {
      id: 3,
      title:
        'Hội thi "Tình đồng hương trên đất Tây Đô" tạo sân chơi lành mạnh, bổ ích cho sinh viên Cà Mau, Bạc Liêu',
      date: "24/06/2024",
      image: ImageAds,
      isMain: false,
    },
    {
      id: 4,
      title:
        'Hội thi "Tình đồng hương trên đất Tây Đô" tạo sân chơi lành mạnh, bổ ích cho sinh viên Cà Mau, Bạc Liêu',
      date: "24/06/2024",
      image: ImageAds,
      isMain: false,
    },
    {
      id: 5,
      title:
        'Hội thi "Tình đồng hương trên đất Tây Đô" tạo sân chơi lành mạnh, bổ ích cho sinh viên Cà Mau, Bạc Liêu',
      date: "24/06/2024",
      image: ImageAds,
      isMain: false,
    },
    {
      id: 6,
      title:
        'Hội thi "Tình đồng hương trên đất Tây Đô" tạo sân chơi lành mạnh, bổ ích cho sinh viên Cà Mau, Bạc Liêu',
      date: "24/06/2024",
      image: ImageAds,
      isMain: false,
    },
  ],
  ads: [
    {
      id: 1,
      image: ImageKatec,
      url: "https://katec.vn/",
      title: "CÔNG TY CỔ PHẦN CÔNG NGHỆ KATEC",
    },
    {
      id: 2,
      image: ImageTrangNguyen,
      url: "https://trangnguyencantho.com/",
      title: "CÔNG TY CỔ PHẦN ĐẦU TƯ TRANG NGUYỄN",
    },
    {
      id: 3,
      image: ImageBanner,
    },
    {
      id: 4,
      image: ImageBanner,
    },
  ],
};

export const newsSlice = createSlice({
  name: "news",
  initialState,
  reducers: {
    setArticles: (state, action) => {
      state.articles = action.payload;
    },
    setAds: (state, action) => {
      state.ads = action.payload;
    },
  },
});

export const { setArticles, setAds } = newsSlice.actions;
export const selectArticles = (state) => state.news.articles;
export const selectAds = (state) => state.news.ads;
export default newsSlice.reducer;
